import React from 'react';

export const dealingWithAdvertisersMessages = {
  value: 'Dealing with Advertisers',
  list: [
    {
      value: (
        <>
          User’s communication or business dealings with, or participation in
          promotions organized by, advertisers found on or through the Site,
          including payment and delivery of related goods or services, and any
          other terms, conditions, warranties or representations associated with
          such dealings, are solely between the user and such advertiser. Glints
          shall not be responsible or liable for any loss or damage of any type
          or nature incurred as a result of any such dealings or as a result of
          the presence of the advertisers on the Site or as a result of the
          accuracy or truthfulness of any information or data posted by the
          advertisers.
        </>
      ),
    },
  ],
};
